<template>
  <div>
    <FeatureAlertCard
      v-if="!account.careerPortal"
    />

    <VCard class="pa-8 start__text my-5">
      <VRow class="align-stretch">
        <VCol cols="12" lg="8">
          <VList class="d-flex justify-space-between">
            <VListItem
              class="flex-column align-start"
            >
              <VListItemTitle v-text="$t('startTextTitle')" class="align-self-start" />
              <VListItemSubtitle v-text="$t('startTextSubtitle')" class="my-4 pb-1" />
              <span>{{ $t('startTextSpan') }}</span>
            </VListItem>
          </VList>
        </VCol>
        <VCol
          cols="12"
          lg="4"
          class="start__text_block-img"
        >
          <template v-if="locale === 'ru'">
            <img class="card-3-img" height="200" src="@/assets/img/laptop-template-ru.png">
          </template>
          <template v-else>
            <img class="card-3-img" height="200" src="@/assets/img/laptop-template-en.png">
          </template>
        </VCol>
      </VRow>
    </VCard>

    <VCard class="pa-8 mb-5 start__steps">
      <VList class="d-flex justify-space-between flex-wrap">
        <VListItem
          v-for="(step, index) in stepsPortal"
          :key="index"
          :value="step"
          class="flex-column align-start col-sm-6"
        >
          <svg
            v-if="step.condition"
            class="start__steps_success-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="40"
              height="40"
              rx="20"
              fill="#1FC57F"
            />
            <path d="M17.1998 26.2833C16.9769 26.2834 16.7562 26.2395 16.5503 26.1542C16.3444 26.0689 16.1573 25.9437 15.9998 25.786L12.2925 22.0807L13.7071 20.6667L17.1998 24.1593L26.2925 15.0667L27.7072 16.4807L18.3998 25.786C18.2423 25.9437 18.0553 26.0689 17.8494 26.1542C17.6434 26.2395 17.4227 26.2834 17.1998 26.2833Z" fill="white" />
          </svg>

          <div class="start__steps_number" v-else>
            {{ index + 1 }}
          </div>

          <VListItemTitle v-text="step.title" class="align-self-start mt-7 mb-2" />

          <VListItemSubtitle v-if="step.id === 0" style="max-width: 165px;">
            {{ step.subtitle }}
            <RouterLink
              class="button-trial"
              :to="{ name: 'career-portal',
                     params: { type: portalTabs.DESIGN } }"
            >
              {{ $t('template') }}
            </RouterLink>
          </VListItemSubtitle>
          <VListItemSubtitle v-if="step.id === 1" style="max-width: 185px;">
            <RouterLink
              class="button-trial"
              :to="{ name: 'career-portal',
                     params: { type: portalTabs.DESIGN } }"
            >
              {{ $t('loadContentSubtitle') }}
            </RouterLink>
            {{ step.subtitle }}
          </VListItemSubtitle>
          <VListItemSubtitle v-if="step.id === 2">
            <RouterLink
              class="button-trial"
              :to="{ name: 'career-portal',
                     params: { type: portalTabs.ARTICLES } }"
            >
              {{ $t('completeBlogSubtitle') }}
            </RouterLink>
            {{ step.subtitle }}
          </VListItemSubtitle>
          <VListItemSubtitle v-if="step.id === 3" style="max-width: 165px;">
            {{ step.subtitle }}
            <RouterLink
              class="button-trial"
              :to="{ name: 'career-portal',
                     params: { type: portalTabs.SETTINGS } }"
            >
              {{ $t('settings') }}
            </RouterLink>
          </VListItemSubtitle>
          <VListItemSubtitle v-if="step.id === 4" style="max-width: 165px;">
            {{ step.subtitle }}
            <div
              class="button-trial"
              @click="publishATemplate"
              href="#"
            >
              {{ $t('careerPortal') }}
            </div>
          </VListItemSubtitle>
        </VListItem>
      </VList>
    </VCard>

    <VBtn color="#EEEEEE" class="btn-goToDesign">
      <RouterLink :to="`/career-portal/design`">
        {{ $t('goToDesign') }}
      </RouterLink>
    </VBtn>

    <VDialog v-model="dialogMakeChanges" persistent max-width="500">
      <VCard>
        <DialogTariffChange :title="$t('youMadeNoChangesAnyTemplate')" @close="cancelDialogMakeChanges">
          <template v-slot:btn>
            <VBtn
              color="success"
              style="padding: 10px 50px; margin: 8px auto 8px;"
              id="inviteBtn"
              @click="cancelDialogMakeChanges"
            >
              {{ $t('ok') }}
            </VBtn>
          </template>
        </DialogTariffChange>
      </VCard>
    </VDialog>

    <VDialog v-model="dialogTariffPlan" persistent max-width="500">
      <VCard>
        <DialogTariffChange :title="$t('career-portal-na')" @close="cancelDialogTariffPlan" />
      </VCard>
    </VDialog>

    <VDialog v-model="dialogTemplatePublished" persistent max-width="500">
      <VCard>
        <DialogTariffChange :title="$t('templateIsPublished')" @close="cancelDialogTemplatePublished">
          <template v-slot:btn>
            <VBtn
              color="success"
              style="padding: 10px 50px; margin: 8px auto 8px;"
              id="inviteBtn"
              @click="cancelDialogTemplatePublished"
            >
              {{ $t('ok') }}
            </VBtn>
          </template>
        </DialogTariffChange>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import { toRefs, computed, ref } from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import { portalTabs } from '@/enums';
import useDomain from '@/compositions/useDomain';
import DialogTariffChange from '../DialogTariffChange.vue';
import FeatureAlertCard from './FeatureAlertCard.vue';

export default {
  name: 'Start',
  components: { FeatureAlertCard, DialogTariffChange },
  props: {
    company: {
      required: true,
      type: Object,
    },
    account: {
      required: true,
      type: Object,
    },
    articles: {
      required: true,
      type: Array,
    },
    domain: {
      required: false,
      default: null,
      type: String,
    },
  },
  setup(props, { root: { $router } }) {
    const {
      articles, company, domain, account,
    } = toRefs(props);
    const { getDomain } = useDomain();
    const { t, locale } = useI18n();

    const articlesLength = computed(() => articles.value.length);
    const templateData = computed(() => company.value.companyTemplateSettings);
    const careerPortalUrl = process.env.VUE_APP_CAREER_PORTAL_URL;
    const dialogMakeChanges = ref(false);
    const dialogTariffPlan = ref(false);
    const dialogTemplatePublished = ref(false);

    const stepsPortal = [
      {
        id: 0, title: t('selectDesign'), subtitle: t('selectDesignSubtitle'), condition: company.value.templateHasChanges,
      },
      {
        id: 1, title: t('loadContent'), subtitle: t('ourCompany'), condition: company.value.templateHasChanges,
      },
      {
        id: 2, title: t('completeBlog'), subtitle: t('usefulCandidates'), condition: articlesLength.value,
      },
      {
        id: 3, title: t('connectDomain'), subtitle: t('connectDomainSubtitle'), condition: domain.value,
      },
      {
        id: 4, title: t('publishTheTemplate'), subtitle: t('publishTheTemplateSubtitle'), condition: templateData.value,
      },
    ];

    function publishATemplate() {
      if (!account.value.careerPortal) {
        dialogTariffPlan.value = true;
        return;
      }

      if (!company.value.templateHasChanges && account.value.careerPortal) {
        dialogMakeChanges.value = true;
        return;
      }

      if (company.value.companyTemplateSettings) {
        dialogTemplatePublished.value = true;
        return;
      }

      $router.push({
        name: 'career-portal',
        params: {
          type: portalTabs.DESIGN,
        },
      });
    }

    function cancelDialogMakeChanges() {
      dialogMakeChanges.value = false;
    }

    function cancelDialogTariffPlan() {
      dialogTariffPlan.value = false;
    }

    function cancelDialogTemplatePublished() {
      dialogTemplatePublished.value = false;
    }

    return {
      t,
      locale,
      stepsPortal,
      careerPortalUrl,
      portalTabs,
      articlesLength,
      templateData,
      getDomain,
      fetch,
      publishATemplate,
      dialogMakeChanges,
      cancelDialogMakeChanges,
      dialogTariffPlan,
      cancelDialogTariffPlan,
      dialogTemplatePublished,
      cancelDialogTemplatePublished,
    };
  },
};
</script>

<style scoped lang="scss">
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.v-card::v-deep {
  background-color: #F5F5F5;
  border-radius: 10px;
}
.v-list::v-deep {
  background-color: #F5F5F5;
}
.v-list-item__subtitle {
  flex: auto;
  overflow: inherit;
}
.start {
  &__trial {
    @media screen and (max-width: 428px) {
      padding: 20px !important;
    }
    background-color: #FFECEC;
    .row {
      display: flex;
      align-items: center !important;
      .try-days-block {
        @media screen and (max-width: 1264px) {
          text-align: start !important;
          margin-top: 25px;
        }
        @media screen and (max-width: 428px) {
          margin-left: 15px;
        }
      }
      .change-tariff-block {
        @media screen and (max-width: 1264px) {
          text-align: start !important;
        }
        @media screen and (max-width: 428px) {
          margin-left: 15px;
        }
      }
    }
    .v-list {
      background-color: #FFECEC;
      > div:nth-child(1) {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #212121 !important;
      }
      > div:nth-child(2) {
        font-weight: 300;
        font-size: 16px;
        line-height: 150%;
        color: #666666 !important;
      }
      .v-list-item {
        min-height: auto;
      }
    }

    .button-trial {
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
    }

    .button-tariff {
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      color: #212121;
    }
  }

  &__steps {
    @media screen and (max-width: 428px) {
      padding: 20px !important;
    }
    .v-list-item::v-deep {
      min-height: auto;
      @media screen and (min-width: 1264px) {
        max-width: 20%;
      }
    }

    .v-list-item__title::v-deep {
      white-space: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 100%;
      color: #212121;
      @media screen and (max-width: 600px) {
        margin: 7px 0 8px 40px !important;
      }
    }
    .v-list-item__subtitle::v-deep {
      white-space: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 120%;
      color: #666666;
      max-width: 210px;
      @media screen and (max-width: 600px) {
        margin-left: 40px;
      }
    }
    &_success-icon {
      height: 100%;
      min-height: 40px;
      @media screen and (max-width: 600px) {
        position: absolute;
        left: 0;
        height: auto;
      }
    }
    &_number {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      padding: 10px;

      background: #fff;
      border: 1px solid #EDEDED;
      text-align: center;

      font-weight: 400;
      font-size: 19px;
      line-height: 100%;
      color: #666666;
      @media screen and (max-width: 600px) {
        position: absolute;
        left: 0;
      }
    }
  }

  &__text {
    @media screen and (max-width: 428px) {
      padding: 20px !important;
    }
    &_block-img {
      @media screen and (max-width: 1264px) {
        text-align: center;
      }
      img {
        @media screen and (max-width: 400px) {
          width: 200px;
        }
      }
    }
    .v-list {
      height: 100%;
    }
    .v-list-item__title {
      max-width: 511px;
      font-weight: 400;
      white-space: normal;
      line-height: 120%;
      color: #212121;
    }
    .v-list-item__subtitle {
      white-space: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 120%;
      color: #666666;
    }
    span {
      white-space: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 120%;
      color: #666666;
    }
  }
}

.button-trial {
  color: #0A82D9 !important;
  text-decoration: underline;
  text-underline-position: under;
  cursor: pointer;
}
.btn-goToDesign {
  span {
    padding: 16px 8px;
    a {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: #212121 !important;
      text-decoration: none;
    }
  }
}
</style>

<i18n lang="yml" locale="en">
  selectDesign: Choose a design
  loadContent: Upload content
  completeBlog: Fill out the page
  connectDomain: Connect a domain to your portal
  publishTheTemplate: Publish the template
  selectDesignSubtitle: Choose the right
  loadContentSubtitle: Edit
  completeBlogSubtitle: Add an article
  connectDomainSubtitle: Set up a domain in
  publishTheTemplateSubtitle: Publish your
  template: template
  ourCompany: the selected template
  usefulCandidates: to display with the template
  settings: Settings
  careerPortal: Career portal
  startTextTitle: Career portal – a specialized version of Huntica for your company to attract employees.
  startTextSubtitle: 'A career portal provides the opportunity to create a personalized website for your company,
  featuring current job openings and a blog, all within a few clicks. Simply choose a template and customize it according to your preferences.
  The career portal automatically collects data from interested candidates.'
  startTextSpan: The career portal is accessible with the "Standard" tariff and above.
  goToDesign: Go to the "Design" tab
  dialogApplyingPublishTemplateTitle: Are you sure you want to publish your Career Portal?
  dialogApplyingPublishTemplateText: After publication, your Career Portal will be available to candidates
  ok: Ok
  cancel: Cancel
  youMadeNoChangesAnyTemplate: You have not made any changes in any template
  career-portal-na: Career portal is unavailable with your plan
  templateIsPublished: Your template has already been published!
  changeTemplate: Change the template
</i18n>

<i18n lang="yml" locale="ru">
  selectDesign: Выберите дизайн
  loadContent: Загрузите контент
  completeBlog: Заполните блог
  connectDomain: Подключите домен
  publishTheTemplate: Опубликуйте шаблон
  selectDesignSubtitle: Подберите подходящий
  loadContentSubtitle: Отредактируйте
  completeBlogSubtitle: Добавьте статью
  connectDomainSubtitle: Настройте домен в
  publishTheTemplateSubtitle: Опубликуйте свой
  template: шаблон
  ourCompany: выбранный шаблон
  usefulCandidates: для отображения в шаблоне
  settings: настройках
  careerPortal: Карьерный портал
  startTextTitle: Карьерный портал – сайт вашей компании на базе Huntica для привлечения сотрудников
  startTextSubtitle: 'Карьерный портал – это возможность создать сайт компании с актуальными вакансиями и блогом за пару кликов.
Достаточно выбрать шаблон и адаптировать его под себя.
Карьерный портал будет сам собирать отклики от заинтересованных кандидатов.'
  startTextSpan: Карьерный портал доступен на тарифе «Стандарт» и выше.
  goToDesign: Перейти на вкладку «Дизайн»
  dialogApplyingPublishTemplateTitle: Вы уверены, что хотите опубликовать свой Карьерный портал?
  dialogApplyingPublishTemplateText: После публикации Ваш Карьерный портал станет доступен для кандидатов
  ok: Oк
  cancel: Отмена
  youMadeNoChangesAnyTemplate: Вы не внесли изменения ни в одном шаблоне
  career-portal-na: Карьерный портал недоступен на вашем тарифе
  templateIsPublished: Ваш шаблон уже опубликован!
  changeTemplate: Сменить шаблон
</i18n>
